// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Z8Ui","alert":"SettungsInbox_alert__2xMq9"};